import { render, staticRenderFns } from "./CommentListOnSlideMenu.vue?vue&type=template&id=18d3c0e9&scoped=true&"
import script from "./CommentListOnSlideMenu.vue?vue&type=script&lang=ts&"
export * from "./CommentListOnSlideMenu.vue?vue&type=script&lang=ts&"
import style0 from "./CommentListOnSlideMenu.vue?vue&type=style&index=0&id=18d3c0e9&lang=scss&scoped=true&"
import style1 from "./CommentListOnSlideMenu.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d3c0e9",
  null
  
)

export default component.exports